// **接口域名的管理**

const base = {
    dev: 'http://debug.bodongshi.cn:18899',
    test: 'https://debug.bodongshi.com',
    // 正式
    // bds: 'https://api.bodongshi.com'
    // 测试
    bds: 'https://superdebugapi.bodongshi.cn',
    // bds: 'http://101.66.242.103:15579',
    // bds: 'http://debug.bodongshi.cn:15579',
    // 天和内测
    // bds: 'https://tianheapi.bodongshi.com',
    // 内测
    // bds: 'https://alphaapi.bodongshi.com',
    // 测试
    // bds: 'https://localapi.bodongshi.cn'
    // 测试新
    // bds: 'https://debug.bodongshi.cn'
}

export default base;


// WEBPACK FOOTER //
// ./src/utils/base.js